export const fetchCart = async ({ BeURL }) => {
    try {
        if (!BeURL || typeof BeURL !== 'string') {
            alert("Backend URL not provided or invalid")
            return []
        }

        const res = await fetch(`${BeURL}/fetch-cart`, { credentials: "include" })
        const data = await res.json()

        if (!data) {
            alert("No data received from server.")
            return []
        }

        if (!data.success) {
            alert(data.message || "Failed to fetch cart.")
            return []
        }

        return data.cart || { courses: [], pricing: { subtotal: 0, tax: 0, discount: 0, totalAmount: 0 } }

    }
    catch (error) {
        console.error("Error validating Backend URL:", error)
        alert("An error occurred while validating the Backend URL.")
        return []
    }
}